import * as React from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button, Dropdown, Input } from "antd";

import Swal from "sweetalert2";

import channelUserApi from "../../apis/ChannelUser.api";
import partnersApi from "../../apis/Partners.api";
import { setChannelUser, setUser } from "../../redux/store/auth/authDuck";
import { setLoading } from "../../redux/store/common/commonDuck";
import { toastAlert } from "../AlertComponent";
import ScreenLoading from "../common/ScreenLoading";

import SignUpHeader from "./SignUpHeader";

const SellerMypage = () => {
	const history = useHistory();
	const user = useSelector((state) => state.auth.user);
	const dispatch = useDispatch();

	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const [bankList, setBankList] = useState([]);
	const [selectedBank, setSelectedBank] = useState({
		code: null,
		name: null,
	}); // 선택한 은행
	const [account, setAccount] = useState(user.account_number ?? "-");

	useEffect(() => {
		getBankList();
	}, []);

	/**
	 * 포트원 은행 리스트 조회
	 * @returns {Promise<void>}
	 * [{
	 * code: 은행코드
	 * name: 은행명
	 * }]
	 */
	const getBankList = async () => {
		try {
			const res = await partnersApi.readBankList();
			if (res.code === 200) {
				let list = res.result;
				setBankList(list);
			}
		} catch (e) {
			console.log("e", e);
		}
	};

	// 은행 리스트
	const items =
		bankList?.length > 0
			? bankList?.map((item) => ({
					label: item.name,
					key: item.code,
			  }))
			: [];

	/**
	 * 은행 목록 클릭
	 * @param key
	 */
	const onBankClick = ({ key }) => {
		let clickBank = bankList.filter((item) => item.code === key);
		if (clickBank?.[0]?.code) {
			setSelectedBank(clickBank?.[0] ?? { code: null, name: null });
		}
	};

	/**
	 * 유저 은행 등록
	 */
	useEffect(() => {
		if (user?.bank_code && bankList?.length > 0) {
			setIsLoading(true);
			let bank = items.filter((item) => item.key === user.bank_code);
			if (bank?.length > 0) {
				setSelectedBank({
					code: bank[0].key,
					name: bank[0].label,
				});
				setIsLoading(false);
			}
		}
	}, [user, bankList]);

	/**
	 * 계좌 번호 입력
	 * @param e
	 */
	const onChangeValue = (e) => {
		let { value } = e.target;
		setAccount(value);
	};

	/**
	 * 취소하기
	 */
	const onClickCancel = () => {
		if (
			selectedBank.code !== user.bank_code ||
			account !== user.account_number
		) {
			Swal.fire({
				customClass: "alert-custom",
				text: `수정 중인 내용이 있습니다. 정말 취소하시겠습니까?`,
				showCancelButton: true,
				confirmButtonText: "확인",
				cancelButtonText: "취소",
			}).then(async (result) => {
				history.goBack();
			});
		} else {
			history.goBack();
		}
	};

	/**
	 * 로그아웃
	 * @returns {Promise<void>}
	 */
	const logout = async () => {
		setIsLoading(true);
		Swal.fire({
			customClass: "alert-custom",
			text: `정말 로그아웃 하시겠습니까?`,
			showCancelButton: true,
			confirmButtonText: "확인",
			cancelButtonText: "취소",
		}).then(async (result) => {
			if (result.isConfirmed) {
				const param = {
					id: user.id,
				};
				await partnersApi.logout(param);
				localStorage.removeItem("admin:accessToken");
				localStorage.removeItem("admin:refreshToken");

				dispatch(setChannelUser(null));
				dispatch(setUser(null));
				setIsLoading(false);
				history.push(`/`);
			}
		});
		setIsLoading(false);
	};

	/**
	 * 수정하기
	 * @returns {Promise<void>}
	 */
	const onClickUserUpdate = async () => {
		setIsLoading(true);
		let param = {
			id: user.id,
			key: "basic_profile",
			bank_code: selectedBank.code,
			account_number: account,
			is_app: false,
		};

		const res = await partnersApi.postPersonalBankAccount(param);
		if (res.code === 200) {
			dispatch(setUser(res.result));
			Swal.fire({
				customClass: "alert-custom",
				text: "성공적으로 수정이 완료되었습니다.",
				confirmButtonText: "확인",
			}).then(() => {
				history.goBack();
			});
		}
		setIsLoading(false);
	};

	/**
	 * 파트너스 탈퇴하기
	 * @returns {Promise<void>}
	 */
	const withdrawUser = async () => {
		Swal.fire({
			customClass: "alert-custom",
			text: "정말 탈퇴하시겠습니까?",
			showCancelButton: true,
			confirmButtonText: "확인",
			cancelButtonText: "취소",
		}).then(async (result) => {
			if (result.isConfirmed) {
				setIsLoading(true);
				let param = {
					userId: user.id,
					isInfluencer: true,
				};
				const res = await channelUserApi.leave(param);
				if (res.code === 200) {
					Swal.fire({
						customClass: "alert-custom",
						text: "탈퇴가 정상적으로 완료되었습니다.",
						confirmButtonText: "확인",
					}).then(() => {
						localStorage.removeItem("admin:accessToken");
						localStorage.removeItem("admin:refreshToken");

						dispatch(setChannelUser(null));
						dispatch(setUser(null));
						setIsLoading(false);
						history.push(`/`);
					});
				} else {
					Swal.fire({
						customClass: "alert-custom",
						text: "오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
						confirmButtonText: "확인",
					}).then(() => {
						setIsLoading(false);
					});
				}
				setIsLoading(false);
			}
		});
	};
	return (
		<div className="main-wrap">
			{isLoading && <ScreenLoading />}
			<div className={`max-width-apply`}>
				{/* 모바일 헤더 추가 */}
				<SignUpHeader title={""} back={true} close={false} />
				<div className={`seller-user-mypage-div`}>
					<h1>
						내 정보를 <span>확인</span>해보세요
					</h1>
					<div className={`mypage-form-body`}>
						<div className={`mypage-title-div`}>
							<p>회원 정보 수정</p>
						</div>
						{/* 연동계정 */}
						<div className={`mypage-form-div`}>
							<label>연동계정</label>
							<div
								className={`mypage-form-item disabled`}
								id={"linked_account"}
							>
								<UserLinkedAccount user={user} />
							</div>
						</div>

						{/* 이름 */}
						<div className={`mypage-form-div`}>
							<label>이름</label>
							<Input
								className={`mypage-form-item`}
								disabled={true}
								value={user.nickname ?? "-"}
								id={"name"}
							/>
						</div>

						{/* 휴대폰 번호 */}
						<div className={`mypage-form-div`}>
							<label>휴대폰 번호</label>
							<Input
								className={`mypage-form-item`}
								disabled={true}
								value={user.phone ?? "-"}
								id={"phone"}
							/>
						</div>

						{/* 은행 */}
						<div className={`mypage-form-div`}>
							<label>은행</label>
							<Dropdown
								menu={{
									items: items,
									onClick: onBankClick,
								}}
								trigger={["click"]}
								overlayStyle={{
									maxHeight: 200,
									overflow: "auto",
									border: "solid 0.3px #97a0aa",
								}}
								disabled={isLoading}
							>
								<button
									className={`mypage-form-item dropdown ${
										selectedBank.name?.length > 0 && "selected"
									}`}
									id={"bank"}
								>
									{selectedBank.name ?? "은행을 선택해주세요"}
									{/*은행을 선택해주세요*/}
									<img
										src={`/assets/images/report/down.png`}
										alt={`드롭다운`}
									/>
								</button>
							</Dropdown>
						</div>

						{/* 계좌 번호 */}
						<div className={`mypage-form-div`}>
							<label>계좌 번호</label>
							<Input
								className={`mypage-form-item`}
								placeholder={`계좌 번호를 입력해주세요`}
								disabled={isLoading}
								value={account ?? "-"}
								onChange={onChangeValue}
								id={`account`}
							/>
						</div>

						{/* 계좌 소유자 */}
						<div className={`mypage-form-div`}>
							<label>계좌 소유자</label>
							<Input
								className={`mypage-form-item`}
								disabled={true}
								value={user.nickname ?? "-"}
								id={`bank_name`}
							/>
						</div>
					</div>
					{/* 계좌번호 오기입 안내 */}
					<div
						className={`mypage-form-div`}
						style={{
							borderBottom: "none",
						}}
					>
						<p className={`mypage-notice-text`}>
							*<span>계좌번호 오기입</span>으로 인해 다른 계좌로 송금 시
							당영투게더에서는 책임지지 않습니다.{"\n"}다시 한번 확인
							부탁드립니다.
						</p>
						<p className={`mypage-notice-text mobile`}>
							*<span>계좌번호 오기입</span>으로 인해 다른 계좌로 송금 시
							당영투게더에서는{"\n"}책임지지 않습니다. 다시 한번 확인
							부탁드립니다.
						</p>
					</div>

					<div className={`mypage-button-group`}>
						<Button
							className={`cancel`}
							onClick={onClickCancel}
							disabled={isLoading}
						>
							취소
						</Button>
						<Button onClick={onClickUserUpdate} loading={isLoading}>
							완료
						</Button>
					</div>
					<div className={`mypage-logout-button-group`}>
						<button onClick={logout} disabled={isLoading}>
							로그아웃
						</button>
						<button onClick={withdrawUser} disabled={isLoading}>
							탈퇴하기
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

const UserLinkedAccount = ({ user }) => {
	const icon = user.provider ? user.provider : "check-active";
	const linked =
		icon === "kakao"
			? "카카오로그인"
			: icon === "naver"
			? "네이버로그인"
			: "일반로그인";
	return (
		<div style={{ display: "flex", alignItems: "center", gap: "0.3em" }}>
			<img
				src={`/assets/images/login/${icon}.png`}
				alt={`${linked}-icon`}
				className={`linked-icon`}
			/>
			<p className={`linked-text`}>{linked}</p>
		</div>
	);
};
export default SellerMypage;
